/* eslint-disable import/namespace */
import * as fingerprint from 'fingerprintjs2';
import { setCookie } from '@cian/utils/lib/browser/cookie';

/*
 Для корректного отпечатка функция НЕ должна выполняться непосредственно во время или сразу после загрузки страницы.
 В примере использования в доке используется requestIdleCallback, переписал c использованием Promise
 */
export const getFingerprintHashPromise = () =>
  new Promise<string>(resolve => {
    // тест есть, но некорректно собирается покрытие из-за колбека
    // istanbul ignore next
    fingerprint.getV18(components => {
      resolve(components);
    });
  });

export const setFingerprintCookie = () =>
  getFingerprintHashPromise().then(fp => {
    setCookie('fingerprint', fp);
  });
